import Search from './views/Search.vue';
import { createApp } from 'vue';

if(document.getElementById('search')){
	const app = createApp(Search);
	app.mount('#search');
}